import { Injectable } from "@angular/core";
import {
    APIService,
    ChatMessageType,
    CreateChatMessageInput,
} from "../API.service";
import { ChatMessage, ChatRecord } from "../types/types.service";

@Injectable({
    providedIn: "root",
})
export class ChatMessageService {
    currentTourID: string;

    tourStartedAt: number;

    constructor(private API: APIService) { }

    async createChatMessage(
        chatMessage: CreateChatMessageInput,
    ): Promise<ChatMessage> {
        return this.API.CreateChatMessage(chatMessage);
    }

    async saveChatMessageFromZoom(
        zoomMessage: ChatRecord,
        type: ChatMessageType = ChatMessageType.DEFAULT,
    ): Promise<ChatMessage> {
        const toAll = zoomMessage.receiver.name === "Everyone";
        const tourID = this.currentTourID;
        const input: CreateChatMessageInput = {
            zoomChatRecord: zoomMessage,
            timestamp: Math.floor(zoomMessage.timestamp / 1000),
            message: Array.isArray(zoomMessage.message)
                ? zoomMessage.message[0]
                : zoomMessage.message,
            authorID: zoomMessage.sender.name,
            visitTemplateID: tourID,
            type,
            toAll,
        };
        if (!toAll) {
            input.receiver = zoomMessage.receiver.name;
        }
        return this.createChatMessage(input);
    }

    async getMessagesSinceVisitStart(): Promise<ChatMessage[]> {
        if (this.currentTourID) {
            return (
                await this.API.ChatMessagesByVisit(this.currentTourID, {
                    ge: Math.floor(this.tourStartedAt / 1000),
                })
            ).items;
        }
        return [];
    }
}
